export const environment = {
  production: true,
  type: window.location.origin,
  apiUrl: `${document.location.protocol}//${document.location.host}/dmint-platform/api`,
  apiUrl2: `${document.location.protocol}//${document.location.host}/user-subs-management/api`,
  auth: {   
    domain: 'dacoval-prod.eu.auth0.com',
    issuer: 'https://dacoval-prod.eu.auth0.com/',
    clientId: 'tJ9fe7j5zX4g29phDOdKjqoz1KwEBd7r',
    clientSecret:
      'gUrRvTsDljVyLFl16-N20n8yLnuyZb__wXyGDnl03R_O_LJwVGlHSISitkAwqeho',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://dmint-platform-api.azurewebsites.net',
      cookieDomain: '.azurewebsites.net',
      useCookiesForTransactions: true,
      SameSite: 'None',
    }
  }
};
